<div class="message message--red" *ngIf="stepsErrors">
  <div class="message__content">
    <div>
      <div class="font-weight-bold mb-16">Не удалось сохранить, так как не заполнены обязательные поля:</div>
      <div class="grid">
        <div *ngFor="let step of stepsErrors | keyvalue" class="grid__box grid__box--size-12 mb-16">
          <div class="grid">
            <div class="grid__box grid__box--size-min">
              {{ step.value.stepName }}
            </div>
            <div class="grid__box grid__box--size-11">
              <div *ngFor="let section of step.value.sections" class="ml-8">
                <div>
                  <div class="grid grid--gap-8">
                    <div class="grid__box grid__box--size-min">
                      <span class="font-weight-bold">{{ section.sectionName }}: </span>
                    </div>
                    <div class="grid__box grid__box--size-10" *ngIf="section.subSections.length">
                      <div *ngFor="let subSection of section.subSections">
                        <div class="grid grid--gap-8">
                          <div class="grid__box grid__box--size-min">
                            <span class="link link--red-dark link--not-hovered"
                              >{{ subSection.subSectionName }}
                              :
                            </span>
                          </div>
                          <div class="grid__box">
                            <span *ngFor="let last = last; let field; of: subSection.fields"> {{ field }}{{ last ? '' : ', ' }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="grid__box">
                      <span *ngFor="let last = last; let field; of: section.fields"> {{ field }}{{ last ? '' : ', ' }} </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="message message--red" *ngIf="backendError">
  <div class="message__content">
    <ng-container *ngIf="isArray(backendError)">
      <div *ngFor="let message of backendError">
        {{ message }}
      </div>
    </ng-container>
    <ng-container *ngIf="!isArray(backendError)">
      {{ backendError }}
    </ng-container>
  </div>
</div>
<div class="message message--red" *ngIf="hasDuplicates">
  <div class="message__content">
    <ul>
      <li *ngIf="duplicationError.phone">
        Номер {{ duplicationError.phone.phone }} уже используется для сотрудника
        <a class="link link--dotted-blue-dark" target="_blank" [routerLink]="['/users', { u_id: duplicationError.phone.user_id }]"
          >{{ duplicationError.phone.last_name }} {{ duplicationError.phone.first_name }}</a
        >
      </li>
      <li *ngIf="duplicationError.email">
        E-mail {{ duplicationError.email.email }} уже используется для сотрудника
        <a class="link link--dotted-blue-dark" target="_blank" [routerLink]="['/users', { u_id: duplicationError.email.user_id }]"
          >{{ duplicationError.email.last_name }} {{ duplicationError.email.first_name }}</a
        >
      </li>
      <li *ngIf="duplicationError.emp_no">
        Табельный номер ВК {{ duplicationError.emp_no.emp_number }} уже используется для сотрудника
        <a class="link link--dotted-blue-dark" target="_blank" [routerLink]="['/users', { u_id: duplicationError.emp_no.user_id }]"
          >{{ duplicationError.emp_no.last_name }} {{ duplicationError.emp_no.first_name }}</a
        >
      </li>
      <li *ngIf="duplicationError.personnel_number">
        Табельный номер подрядчика
        {{ duplicationError.personnel_number.personnel_number }} уже используется для сотрудника
        <a class="link link--dotted-blue-dark" target="_blank" [routerLink]="['/users', { u_id: duplicationError.personnel_number.user_id }]"
          >{{ duplicationError.personnel_number.last_name }} {{ duplicationError.personnel_number.first_name }}</a
        >
      </li>
    </ul>
  </div>
</div>
